import React from 'react';
import { parseYoutubeVideoId, getYoutubeEmbedSrc } from '../utils/productMedia';

const YOUTUBE_IFRAME_ALLOW =
  'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

/**
 * Renders a YouTube embed (watch/share URL) or a plain img for image URLs.
 */
export function ProductEmbedOrImage({ url, title, imageClassName, onImageError }) {
  if (!url) return null;
  const yid = parseYoutubeVideoId(url);
  const embedSrc = yid ? getYoutubeEmbedSrc(yid) : null;
  if (embedSrc) {
    return (
      <iframe
        key={url}
        title={title}
        src={embedSrc}
        className={`${imageClassName} ${imageClassName}--youtube`.trim()}
        allow={YOUTUBE_IFRAME_ALLOW}
        allowFullScreen
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    );
  }
  return (
    <img
      key={url}
      src={url}
      alt={title}
      className={imageClassName}
      onError={onImageError}
    />
  );
}
